// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"status-logo__iconContainer___J7K5T","enlargeIconContainer":"status-logo__enlargeIconContainer___1ilKl","icon":"status-logo__icon___kWT5i"};